import React from "react";
import { OuterContainer, ImageContainer, StyledImage } from "./styled";
var IMAGE_SIZE = 100;
var ModalHeaderImage = function (_a) {
    var image = _a.image, margin = _a.margin;
    // adding -1 to margin to close the gap created by the border on the svg, we might rework that in the future
    return (React.createElement(ImageContainer, { size: IMAGE_SIZE, marginLeft: margin - 1 },
        React.createElement(OuterContainer, { size: IMAGE_SIZE },
            React.createElement(StyledImage, { src: image, size: IMAGE_SIZE, alt: "modal_image" }))));
};
export default ModalHeaderImage;
